import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-ac-report-layout',
  templateUrl: './ac-report-layout.component.html',
  styleUrls: ['./ac-report-layout.component.css']
})
export class AcReportLayoutComponent implements OnInit {
    acReportLayoutKeyno;

    public edit?: Edit;

    public selectListAcReportLayouts: AcReportLayoutsItem[] = [];

    public saving = false;

    constructor(private state: StateService, private datatask: DataTaskService, private modal: ModalService) {
        this.acReportLayoutKeyno = this.state.getStateParams()['acreportlayout_keyno'];
    }

    private async loadEdit() {
        if (!!this.acReportLayoutKeyno) {
            this.edit = (await this.datatask.Post(2803, { acreportlayout_keyno: this.acReportLayoutKeyno }))[0];
        }
    }

    private loadAcReportLayouts(acReportLayoutKeyno: string): Promise<AcReportLayoutsItem[]> {
        return this.datatask.Post(2812, { acreportlayout_keyno: acReportLayoutKeyno });
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2804, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: response.errormessage });
                } else {
                    this.state.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();

        if (!!this.edit?.acreportlayout_keyno) {
            this.selectListAcReportLayouts = await this.loadAcReportLayouts(this.edit!.acreportlayout_keyno);
        }
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    acreportlayout_keyno: string;
    acreportlayout_name: string;
    acreportlayoutline_keyno_100: string;
    res: string;
}

interface AcReportLayoutsItem {
    acreportlayoutline_keyno: string;
    acreportlayoutline_name: string;
    orderby: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('acReportLayout', {
//        templateUrl: 'views/components/views/acReportLayout/acReportLayout.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'utilityService', 'modalService', 'acReportLayoutService', function ($stateParams, stateService, translateService, utilityService, modalService, acReportLayoutService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let acReportLayoutKeyno = $stateParams.acreportlayout_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListAcReportLayouts: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await acReportLayoutService.getAcReportLayout({ acreportlayout_keyno: acReportLayoutKeyno }))[0];

//                return loadAcReportLayouts();
//            }

//            async function loadAcReportLayouts() {
//                if (utilityService.validateParmsValue(vm.model.edit.acreportlayout_keyno, true) !== true) return;

//                return vm.model.selectListAcReportLayouts = await acReportLayoutService.listAcReportLayouts({ acreportlayout_keyno: vm.model.edit.acreportlayout_keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                acReportLayoutService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
